/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkingTimeCostBreakdown
 */
export interface WorkingTimeCostBreakdown {
    /**
     * Start datetime of a period of this hourly rate.
     * @type {Date}
     * @memberof WorkingTimeCostBreakdown
     */
    datetimeFrom: Date;
    /**
     * End datetime of a period of this hourly rate.
     * @type {Date}
     * @memberof WorkingTimeCostBreakdown
     */
    datetimeTo: Date;
    /**
     * Reference to the employee pay details record that determined the hourly rate.
     * @type {number}
     * @memberof WorkingTimeCostBreakdown
     */
    employeePayDetailId: number;
    /**
     * The hourly rate.
     * @type {number}
     * @memberof WorkingTimeCostBreakdown
     */
    hourlyRate: number;
}

/**
 * Check if a given object implements the WorkingTimeCostBreakdown interface.
 */
export function instanceOfWorkingTimeCostBreakdown(value: object): value is WorkingTimeCostBreakdown {
    if (!('datetimeFrom' in value) || value['datetimeFrom'] === undefined) return false;
    if (!('datetimeTo' in value) || value['datetimeTo'] === undefined) return false;
    if (!('employeePayDetailId' in value) || value['employeePayDetailId'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    return true;
}

export function WorkingTimeCostBreakdownFromJSON(json: any): WorkingTimeCostBreakdown {
    return WorkingTimeCostBreakdownFromJSONTyped(json, false);
}

export function WorkingTimeCostBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkingTimeCostBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'datetimeFrom': (new Date(json['datetimeFrom'])),
        'datetimeTo': (new Date(json['datetimeTo'])),
        'employeePayDetailId': json['employeePayDetailId'],
        'hourlyRate': json['hourlyRate'],
    };
}

  export function WorkingTimeCostBreakdownToJSON(json: any): WorkingTimeCostBreakdown {
      return WorkingTimeCostBreakdownToJSONTyped(json, false);
  }

  export function WorkingTimeCostBreakdownToJSONTyped(value?: WorkingTimeCostBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetimeFrom': ((value['datetimeFrom']).toISOString()),
        'datetimeTo': ((value['datetimeTo']).toISOString()),
        'employeePayDetailId': value['employeePayDetailId'],
        'hourlyRate': value['hourlyRate'],
    };
}

